import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/promo-settings-options'
const hierarchyLevelsUrl = `${baseUrl}/hierarchy-levels`
const targetVariablesUrl = `${baseUrl}/target-variables`
const constraintsUrl = `${baseUrl}/constraints`

interface Endpoints {
  createAllHierarchyLevels: NoParamEndpointConstructor
  createAllTargetVariables: NoParamEndpointConstructor
  createAllConstraints: NoParamEndpointConstructor
  getAllHierarchyLevels: NoParamEndpointConstructor
  getAllTargetVariables: NoParamEndpointConstructor
  getAllConstraints: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  remove: SingleParamEndpointConstructor
}

export const promoSettingsEndpoints: Endpoints = {
  createAllHierarchyLevels: () => hierarchyLevelsUrl,
  createAllTargetVariables: () => targetVariablesUrl,
  createAllConstraints: () => constraintsUrl,
  getAllHierarchyLevels: () => hierarchyLevelsUrl,
  getAllTargetVariables: () => targetVariablesUrl,
  getAllConstraints: () => constraintsUrl,
  update: (id) => `${baseUrl}/${id}`,
  remove: (id) => `${baseUrl}/${id}`,
}
